import { Box, Heading, VStack } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

export const Footer: React.FC = () => (
  <VStack
    backgroundColor="black"
    color="white"
    w="full"
    flex="1"
    py={['20px', '40px']}
    alignContent={'left'}
    maxW={'730px'}>
    {/* Disclosure */}
    <Box mt={'60px'}>
      <Heading
        fontWeight={'400'}
        textAlign={'center'}
        fontFamily={FontFamily.DM_SERIF_DISPLAY_REGULAR}
        fontSize={['2xl', '4xl']}>
        Important Disclosures
      </Heading>
      <TextBlock color="white" fontSize={'12px'} mt={'30px'}>
        Concreit, Inc. the manager of the rental properties. Concreit Fund Management is not the investment adviser
        managing the investment vehicles that contain the rental properties. All securities related activities will be
        conducted through Dalmore Group, LLC (“Dalmore”), a Delaware LLC, and a securities broker-dealer registered with
        the U.S. Securities and Exchange Commission and a member of FINRA and SIPC. Dalmore is a provider of execution
        and other brokerage services related to our equity securities transactions. You should speak with your financial
        advisor, accountant and/or attorney when evaluating any real estate offering.
      </TextBlock>
      <TextBlock color="white" fontSize={'12px'} mt={'30px'}>
        Investing in real estate involves risks including the potential loss of principal. A real estate portfolio is
        subject to risks similar to those associated with the direct ownership of real estate and real estate debt, as
        the investments are sensitive to factors such as changes to real estate values and property taxes, interest
        rates, cash flow of underlying real estate assets, supply and demand, and the management skill and credit
        worthiness of the issuer & borrowers. Portfolios concentrated in real estate assets may experience price
        volatility and other risks associated with non-diversification. US real estate investments may also be affected
        by tax and regulatory requirements. Economic factors, market conditions, and investment strategies will affect
        the performance of any portfolio and there is no assurance that a portfolio will match or outperform any
        particular benchmark. There is no guarantee that investment objectives will be achieved, and past performance is
        not indicative of future results.
      </TextBlock>
      <TextBlock color="white" fontSize={'12px'} mt={'30px'}>
        We are testing the waters under Regulation A, of the Securities Act of 1933, as amended. No money or other
        consideration is being solicited at this time and if sent in to us will not be accepted. We are merely
        soliciting indications of interest at this time. No offer to buy securities can be accepted and no part of the
        purchase price can be received until our offering statement is qualified with the SEC. Any such offer to buy
        securities prior to qualification may be withdrawn or revoked, without obligation or commitment of any kind, at
        any time. Indications of interest in our offering involve no obligation or commitment of any kind.
      </TextBlock>
    </Box>
    {/* Contact and Links */}
    {/* <Box>
      <TextBlock>Contact And Links</TextBlock>
    </Box> */}
    {/* Copyright */}
    <Box width={'100%'}>
      <TextBlock color="white" fontSize={'12px'} mt={'30px'} weight="bold" textAlign={'left'}>
        &copy; {new Date().getFullYear()} Concreit Inc. All Rights Reserved. Designed & developed in Seattle.
      </TextBlock>
    </Box>
  </VStack>
);
